"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = void 0;
const mixpanel_browser_1 = __importDefault(require("mixpanel-browser"));
const lastTouchUTMs_1 = require("./lastTouchUTMs");
const init = _ref => {
  let {
    APP_NAME,
    GOOGLE_ADS_ID,
    GOOGLE_ADS_SIGNUP_TAG_ID,
    MIXPANEL_TOKEN,
    channel = "web",
    mixpanel = mixpanel_browser_1.default
  } = _ref;
  return async function useAnalytics(event) {
    if (channel === "mobile") {
      // @ts-ignore mobile library has no params
      mixpanel.init();
    } else {
      mixpanel.init(MIXPANEL_TOKEN);
    }
    // Don't break during SSR
    if (typeof document !== "undefined" && channel !== "mobile") {
      (0, lastTouchUTMs_1.campaignParams)(mixpanel);
    }
    let func;
    switch (event) {
      case "signupAttempt":
        {
          func = args => {
            mixpanel.track("all:signup_attempted", {
              email: args.email,
              app: APP_NAME,
              channel,
              ...(args.method ? {
                method: args.method
              } : {})
            });
            mixpanel.alias(args.email);
            mixpanel.people.set_once({
              $email: args.email,
              "Sign Up Date": new Date().toISOString(),
              "Account Type": "IFG Wealth"
            });
            mixpanel.identify(args.email);
            // only available in production
            if (window.gtag) {
              window.gtag("event", "conversion", {
                send_to: `${GOOGLE_ADS_ID}/${GOOGLE_ADS_SIGNUP_TAG_ID}`
              });
            }
          };
          break;
        }
      case "signupSuccess":
        {
          func = args => {
            mixpanel.track("all:signup_success", {
              email: args.email,
              app: APP_NAME,
              distinct_id: args.email
            });
          };
          break;
        }
      case "login":
        {
          func = args => {
            mixpanel.track("all:login_attempted", {
              email: args.email,
              app: APP_NAME,
              channel,
              ...(args.method ? {
                method: args.method
              } : {})
            });
            mixpanel.people.set({
              LatestLoginDate: new Date().toISOString()
            });
            mixpanel.people.append("list_logins", new Date().toISOString());
            mixpanel.identify(args.email);
          };
          break;
        }
      case "pageView":
        {
          func = args => {
            const {
              eventName,
              ...rest
            } = args;
            mixpanel.track(eventName, {
              ...rest,
              app: APP_NAME,
              channel
            });
          };
          break;
        }
      case "tabChanged":
        {
          func = args => {
            mixpanel.track(`${args.eventName}`, {
              app: APP_NAME,
              tab_id: args.tab_id
            });
          };
          break;
        }
      case "willSubmission":
        {
          func = () => {
            mixpanel.track("wills:checkout_clicked", {
              app: APP_NAME
            });
          };
          break;
        }
      case "compareShortlist":
        {
          func = args => {
            mixpanel.track("compare:shortlist_clicked", {
              ...args,
              app: APP_NAME
            });
          };
          break;
        }
      case "compareInvest":
        {
          func = args => {
            mixpanel.track("compare:investNow_clicked", {
              ...args,
              app: APP_NAME
            });
          };
          break;
        }
      case "insightViewClick":
        {
          func = args => {
            mixpanel.track("track:insight_clicked", {
              ...args,
              app: APP_NAME
            });
          };
          break;
        }
      case "insightCTAClick":
        {
          func = args => {
            mixpanel.track("track:insightCTA_clicked", {
              ...args,
              app: APP_NAME
            });
          };
          break;
        }
      case "cur8JoinClick":
        {
          func = () => {
            mixpanel.track("wealth:cur8ProductPageJoin_clicked", {
              app: APP_NAME
            });
          };
          break;
        }
      case "forogtPasswordClick":
        {
          func = () => {
            mixpanel.track("all:forgotPassword_clicked", {
              app: APP_NAME,
              channel
            });
          };
          break;
        }
      case "forogtPasswordSubmitEmailClick":
        {
          func = args => {
            mixpanel.track("all:forgotPasswordSubmitEmail_clicked", {
              ...args,
              app: APP_NAME,
              channel
            });
          };
          break;
        }
      case "forogtPasswordSetPasswordClick":
        {
          func = () => {
            mixpanel.track("all:forgotPasswordSetPassword_clicked", {
              app: APP_NAME
            });
          };
          break;
        }
      case "appSwitch":
        {
          func = async args => {
            mixpanel.track("all:app_switched", {
              From: APP_NAME,
              To: args.destination,
              app: APP_NAME
            });
          };
          break;
        }
      case "cur8DealDetailsPageView":
        {
          func = async args => {
            mixpanel.track("cur8:dealDetails_pageViewed", {
              ...args,
              app: APP_NAME,
              channel
            });
          };
          break;
        }
      case "cur8DealDetailsCommitInvestmentClick":
        {
          func = async args => {
            mixpanel.track("cur8:dealDetailsCommitInvestment_clicked", {
              ...args,
              app: APP_NAME,
              channel
            });
          };
          break;
        }
      case "compareCryptoBuyNowClick":
        {
          func = async args => {
            mixpanel.track("compare:cryptoBuyNowClicked", {
              ...args,
              app: APP_NAME
            });
          };
          break;
        }
      case "cur8BankDetailsPageView":
        {
          func = async args => {
            mixpanel.track("cur8:bankDetails_pageViewed", {
              ...args,
              app: APP_NAME,
              channel
            });
          };
          break;
        }
      case "appOpened":
        {
          func = async args => {
            mixpanel.track("all:app_opened", {
              ...args,
              app: APP_NAME
            });
          };
          break;
        }
      case "appClosed":
        {
          func = async args => {
            mixpanel.track("all:app_closed", {
              ...args,
              app: APP_NAME
            });
          };
          break;
        }
      case "notificationCTAClicked":
        {
          func = async _ref2 => {
            let {
              name
            } = _ref2;
            mixpanel.track("cur8:notificationCTA_clicked", {
              channel,
              app: APP_NAME,
              notification_name: name
            });
          };
          break;
        }
      case "notificationsEnabled":
        {
          func = async args => {
            mixpanel.track("cur8:notifications_enabled", {
              ...args,
              channel,
              app: APP_NAME
            });
          };
          break;
        }
      case "notificationsDisabled":
        {
          func = async args => {
            mixpanel.track("cur8:notifications_disabled", {
              ...args,
              channel,
              app: APP_NAME
            });
          };
          break;
        }
      case "notificationPromptCTA_clicked":
        {
          func = async args => {
            mixpanel.track("cur8:notificationPromptCTA_clicked", {
              ...args,
              channel,
              app: APP_NAME
            });
          };
          break;
        }
      case "kycYotiCheck":
        {
          func = async args => {
            mixpanel.track("cur8:yotiKyc_check", {
              ...args,
              channel,
              app: APP_NAME
            });
          };
          break;
        }
      case "addInvestmentClicked":
        {
          func = async _ref3 => {
            let {
              deal_name,
              ...args
            } = _ref3;
            mixpanel.track("cur8:addInvestment_clicked", {
              ...args,
              channel,
              app: APP_NAME,
              deal_name
            });
          };
          break;
        }
      case "setNPS":
        {
          func = _ref4 => {
            let {
              NPS,
              email
            } = _ref4;
            mixpanel.identify(email);
            mixpanel.people.set({
              NPS
            });
          };
          break;
        }
      case "setNPSReason":
        {
          func = _ref5 => {
            let {
              NPSReason,
              email
            } = _ref5;
            mixpanel.identify(email);
            mixpanel.people.set({
              NPSReason
            });
          };
          break;
        }
      case "downloadInvestmentStatementClick":
        {
          func = async args => {
            mixpanel.track("cur8:generateInvestmentStatement_clicked’", {
              ...args,
              channel,
              app: APP_NAME
            });
          };
          break;
        }
      case "withdrawClick":
        {
          func = async args => {
            mixpanel.track("cur8:withdrawButton_clicked", {
              ...args,
              channel,
              app: APP_NAME
            });
          };
          break;
        }
      case "getMembershipClicked":
        {
          func = async args => {
            mixpanel.track("cur8:getMembership_clicked", {
              ...args,
              channel,
              app: APP_NAME
            });
          };
          break;
        }
      case "membershipPurchased":
        {
          func = async args => {
            mixpanel.track("cur8:membership_purchased", {
              ...args,
              channel,
              app: APP_NAME
            });
          };
          break;
        }
      case "feesAndReturnsCalculatorInvestNow":
        {
          func = args => {
            mixpanel.track("cur8:feesAndReturnsCalculator_investNow", {
              ...args,
              app: APP_NAME
            });
          };
          break;
        }
      case "zakatCalculatorClicked":
        {
          func = args => {
            mixpanel.track("zakat:zakatCalculator_viewed", {
              ...args,
              app: APP_NAME
            });
          };
          break;
        }
      case "zakatCalculatorCompleted":
        {
          func = args => {
            mixpanel.track("zakat:zakatCalculator_completed", {
              ...args,
              app: APP_NAME
            });
          };
          break;
        }
      default:
        func = () => {
          console.log("Analytics operation failed");
        };
        break;
    }
    return func;
  };
};
exports.init = init;